/* IRIS theme — small, dependency-free behaviours */
(() => {
  document.documentElement.classList.remove('no-js');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const overlay = $('#DrawerOverlay');

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const fmt = (window.IRIS && IRIS.moneyFormat) || '{{amount}}';
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const withCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, `${int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${dec}`)
      .replace(/\{\{\s*amount\s*\}\}/, `${withCommas}.${dec}`);
  }

  /* ---------- Drawers ---------- */
  let openDrawer = null;
  function open(el) {
    if (!el) return;
    close();
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
    openDrawer = el;
    const f = el.querySelector('button, a, input');
    f && f.focus({ preventScroll: true });
  }
  function close() {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    openDrawer.setAttribute('aria-hidden', 'true');
    overlay && overlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    openDrawer = null;
  }
  overlay && overlay.addEventListener('click', close);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); closeModal(); } });
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-open-menu]');
    if (t) { e.preventDefault(); open($('#MenuDrawer')); }
    const c = e.target.closest('[data-open-cart]');
    if (c && $('#CartDrawer')) { e.preventDefault(); open($('#CartDrawer')); }
    if (e.target.closest('[data-close-drawer]')) { e.preventDefault(); close(); }
  });

  /* ---------- Header: solid after scrolling past hero ---------- */
  const header = $('.header');
  const overlayHeader = $('.header-wrap--overlay');
  if (header && overlayHeader) {
    const onScroll = () => header.classList.toggle('is-solid', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    overlayHeader.addEventListener('mouseenter', () => header.classList.add('is-solid'));
    overlayHeader.addEventListener('mouseleave', onScroll);
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(el => io.observe(el));
  } else {
    $$('.reveal').forEach(el => el.classList.add('is-visible'));
  }

  /* ---------- Cart ---------- */
  async function refreshCart(openAfter) {
    try {
      const res = await fetch(`${IRIS.routes.root}?sections=cart-drawer`);
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.querySelector('#CartDrawerInner');
      const current = $('#CartDrawerInner');
      if (fresh && current) current.replaceWith(fresh);
      const cart = await (await fetch(`${IRIS.routes.cart}.js`)).json();
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
      if (openAfter) open($('#CartDrawer'));
    } catch (e) { console.error(e); }
  }

  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || !$('#CartDrawer')) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    const err = form.querySelector('[data-form-error]');
    if (err) err.textContent = '';
    try {
      // "Complete the look": ticked add-ons go in the same request as the main piece
      const addons = Array.from(form.querySelectorAll('[data-addon]'))
        .filter(a => a.querySelector('[data-addon-toggle]').checked)
        .map(a => ({ id: Number(a.querySelector('[data-addon-variant]').value), quantity: 1 }));
      const body = addons.length
        ? JSON.stringify({ items: [{ id: Number(form.querySelector('input[name="id"]').value), quantity: Number(form.querySelector('[name="quantity"]')?.value || 1) }, ...addons] })
        : new FormData(form);
      const res = await fetch(`${IRIS.routes.cartAdd}.js`, {
        method: 'POST',
        headers: addons.length ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
        body
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || 'This piece could not be added.');
      await refreshCart(true);
    } catch (ex) {
      if (err) err.textContent = ex.message;
    } finally {
      btn.disabled = false;
      btn.innerHTML = label;
    }
  });

  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    await fetch(`${IRIS.routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(b.dataset.line), quantity: Number(b.dataset.quantity) })
    });
    if ($('#CartDrawer') && b.closest('#CartDrawer')) refreshCart(false);
    else window.location.reload();
  });

  /* ---------- Product variant picker ---------- */
  $$('[data-product]').forEach(root => {
    const jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const idInput = root.querySelector('input[name="id"]');
    const priceEl = root.querySelector('[data-price]');
    const btn = root.querySelector('[data-add-button]');

    function selected() {
      return $$('[data-option-index]', root).map(fs => {
        const c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function update() {
      const opts = selected();
      const v = product.variants.find(x => x.options.every((o, i) => o === opts[i]));
      // mark sizes that are sold out given other selections
      $$('[data-option-index]', root).forEach((fs, idx) => {
        $$('input', fs).forEach(inp => {
          const test = opts.slice(); test[idx] = inp.value;
          const match = product.variants.find(x => x.options.every((o, i) => o === test[i]));
          inp.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = v.compare_at_price > v.price
          ? `<s>${formatMoney(v.compare_at_price)}</s>${formatMoney(v.price)}`
          : formatMoney(v.price);
      }
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.addLabel : 'This edition is sold out';
      // keep add-on sizes in step with the main piece where that size exists
      $$('[data-addon] select[data-addon-variant]', root).forEach(sel => {
        const match = Array.from(sel.options).find(o => o.dataset.title === v.title && !o.disabled);
        if (match) sel.value = match.value;
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.addEventListener('change', e => { if (e.target.closest('[data-option-index]')) update(); });
    update();
  });

  /* ---------- Modals ---------- */
  function closeModal() { $$('.modal.is-open').forEach(m => { m.classList.remove('is-open'); document.body.classList.remove('no-scroll'); }); }
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-iris-modal]');
    if (t && t.dataset.irisModal === 'SizeGuide') {
      // Prefer the product's Kiwi size chart when the app has one for this product
      const kiwi = document.querySelector('.ks-chart-modal-link');
      if (kiwi) { e.preventDefault(); kiwi.click(); return; }
    }
    if (t) { e.preventDefault(); const m = document.getElementById(t.dataset.irisModal); if (m) { m.classList.add('is-open'); document.body.classList.add('no-scroll'); m.querySelector('.modal__close')?.focus(); } }
    if (e.target.closest('[data-iris-close]')) { e.preventDefault(); closeModal(); }
  });

  /* ---------- Sort select on collections ---------- */
  $$('[data-sort]').forEach(sel => sel.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    window.location.href = url.toString();
  }));
})();
